const removeStylesFromHtmlString = (htmlString: string) => {
  return htmlString
    .replaceAll(/ style="[^"]*"/g, '')
    .replaceAll(/ color="[^"]*"/g, '')
    .replaceAll(/ dir="[^"]*"/g, '')
    .replaceAll(/ face="[^"]*"/g, '')
}

export default removeStylesFromHtmlString
